import PageHeader from './PageHeader';

export default PageHeader;

export type { IPageHeaderProps } from './PageHeader';
